<div *ngIf="showModal" class="modal-overlay">
  <div class="modal-content">
    <!-- Header do Modal -->
    <div class="modal-header">
      <div class="titulo-modal">
        <h2>{{ tituloModalAutorizacao }}</h2>
      </div>
      <button class="btn-fechar-modal" (click)="closeModal()">✖</button>
    </div>
    <p>
      Caro(a) Psicólogo(a), {{userLogado?.nome}}<br />
      Para registrar o início da sua atividade, é necessário que você autorize a utilização dos seus dados pessoais. Esses dados serão utilizados exclusivamente para fins de registro de suas atividades no sistema, garantindo a integridade das informações e o cumprimento de nossas obrigações legais e administrativas. Informações coletadas ( Nome, CPF, CRP, Data e horário de registro, Informações da escola vinculada (CIE e nome)). O tratamento dos seus dados será realizado de acordo com a Lei Geral de Proteção de Dados (LGPD), garantindo a segurança, confidencialidade e uso adequado das informações.
      <br />
      <b>
        <a
          href="javascript:void(0)"
          routerLink="/termos-de-uso-de-dados"
          title="Ir para a página de Termos de Uso de Dados Pessoais"
        >
          Mais Informações
        </a>
      </b>
    </p>

    <!-- Footer do Modal -->
    <div class="modal-footer">
      <button class="btn_segundario" (click)="onClick(0)">
        Não
      </button>
      <button class="btn_primeiro" (click)="onClick(1)">
        Sim
      </button>
    </div>

  </div>
</div>
